import { render, staticRenderFns } from "./base-data-v2.vue?vue&type=template&id=7d74c6cc&scoped=true"
import script from "./base-data-v2.vue?vue&type=script&lang=js"
export * from "./base-data-v2.vue?vue&type=script&lang=js"
import style0 from "./base-data-v2.vue?vue&type=style&index=0&id=7d74c6cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74c6cc",
  null
  
)

export default component.exports